import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { lowerCase, startCase, upperFirst } from 'lodash'

// Initialize dayjs plugins
dayjs.extend(customParseFormat)

const enums = [
  'type',
  'disposition',
  'status',
  'identityProviders',
  'level',
  'ownershipType',
  'propertyType',
  'role',
  'roofType',
]

const flattenItem = (obj: any, prefix = '', ignoredFields: string[], result: any = {}) => {
  for (let key in obj) {
    const finalKey = startCase(prefix + key)

    if (ignoredFields.includes(key)) {
      continue
    }

    if (enums.includes(key)) {
      result[finalKey] = upperFirst(lowerCase(obj[key]))
      continue
    }

    // Check if value is a Date object
    if (obj[key] instanceof Date) {
      // Format the date based on time components
      const date = dayjs(obj[key])
      const hasTime =
        obj[key].getHours() > 0 || obj[key].getMinutes() > 0 || obj[key].getSeconds() > 0

      if (hasTime) {
        result[finalKey] = date.format('MMM DD, YYYY h:mma')
      } else {
        result[finalKey] = date.format('MMM DD, YYYY')
      }
      continue
    }

    // Handle time strings (HH:MM:SS format)
    if (
      typeof obj[key] === 'string' &&
      /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/.test(obj[key])
    ) {
      result[finalKey] = dayjs('1/1/2020 ' + obj[key]).format('h:mma')
      continue
    }

    if (typeof obj[key] === 'object' && obj[key] !== null) {
      Object.assign(result, flattenItem(obj[key], prefix + key + '.', ignoredFields))
    } else {
      result[finalKey] = obj[key]
    }
  }
  return result
}

export const flatten = (obj: any[], ignoredFields: string[]): any[] => {
  const results: any[] = []

  for (const item of obj) {
    const result = flattenItem(item, '', ignoredFields)
    results.push(result)
  }

  return results
}
